// 公式ドキュメントの例に基づくCognito OIDC設定
export const cognitoOIDCConfig = {
  authority:
    import.meta.env.VITE_COGNITO_AUTHORITY || 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_NMLHdQdZ6',
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID || 'lo24sdblbtbc916428vjjk5gp',
  //redirect_uri: window.location.origin + '/login',
  redirect_uri: import.meta.env.VITE_COGNITO_REDIRECT_URI || 'http://localhost:4010/login',
  post_logout_redirect_uri: import.meta.env.VITE_COGNITO_POST_LOGOUT_REDIRECT_URI || 'http://localhost:4010/logout',
  response_type: 'code',
  scope: 'email openid phone profile', // カスタム属性を含むためにprofile scopeを追加
  automaticSilentRenew: false, // 自動サイレント更新を無効にして、自動リダイレクトを回避
  includeIdTokenInSilentRenew: false, // サイレント更新でのID Tokenを無効にする
  revokeAccessTokenOnSignout: true,
  loadUserInfo: false, // ユーザー情報の自動読み込みを無効にする
  monitorSession: false, // セッション監視を無効にする
  checkSessionInterval: 0, // セッションチェック間隔を無効にする
  //prompt: 'login',
};

// Cognitoドメイン設定（ログアウト用）
export const cognitoDomainConfig = {
  domain: import.meta.env.VITE_COGNITO_DOMAIN || 'https://us-east-1nmlhdqdz6.auth.us-east-1.amazoncognito.com',
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || 'lo24sdblbtbc916428vjjk5gp',
};
